<ng-template #actualCalendar>
    <ngb-datepicker
        *ngIf="service.internalInfoForEachDay"
        #d
        (dateSelect)="onDateSelection($event)"
        [displayMonths]="showSingleMonth ? 1 : totalMonths"
        [dayTemplate]="service.isSingleDate ? daySingleSelect : dayRangeSelect"
        style="border: none"
        [navigation]="'none'"
        [weekdays]="false"
        [firstDayOfWeek]="7"
        [footerTemplate]="
            !hasRenderedAsMobile && !showDesktopInPopup ? footer : undefined
        "
        [minDate]="today"
    >
        <ng-template ngbDatepickerContent>
            <ng-container *ngIf="hasRenderedAsMobile">
                <div class="c-picker-header">
                    <ng-container
                        *ngIf="showSelectionSummary && formattedFromDate"
                    >
                        <div *ngIf="totalNights > 0" class="c-popup-header">
                            <div class="c-popup-header-nights">
                                {{ totalNights }} {{ "nights" | translate }}
                            </div>
                            <div class="c-popup-header-dates">
                                <span>{{ formattedFromDate }}</span>
                                <span> - {{ formattedToDate }}</span>
                            </div>
                        </div>
                    </ng-container>
                    <div
                        *ngIf="service.isSingleDate"
                        class="c-picker-mobile-header-dates"
                    >
                        <span>{{ formattedSingleDate }}</span>
                    </div>
                    <ng-container
                        *ngTemplateOutlet="weekDayHeader"
                    ></ng-container>
                </div>
                <div
                    class="c-picker-header-margin"
                    [ngClass]="{
            'with-date-selection': showSelectionSummary && totalNights,
            'with-single-date-selection': showSelectionSummary && formattedSingleDate,
        }"
                ></div>
                <div
                    class="c-month-container"
                    *ngFor="let monthStruct of d.state.months"
                >
                    <div class="c-month-mobile-title">
                        <h4>
                            {{ d.i18n.getMonthFullName(monthStruct.month) }}
                            {{ monthStruct.year }}
                        </h4>
                    </div>
                    <ngb-datepicker-month
                        class="c-picker-mobile-month"
                        [month]="monthStruct"
                    ></ngb-datepicker-month>
                </div>
            </ng-container>
            <ng-container *ngIf="!hasRenderedAsMobile">
                <ng-container *ngIf="showDesktopInPopup">
                    <div style="display: flex; flex-direction: row">
                        <div
                            class="c-month-container"
                            [ngClass]="{ 'multi-month': !showSingleMonth }"
                            *ngFor="
                                let monthStruct of d.state.months;
                                let i = index
                            "
                        >
                            <div class="c-picker-desktop-header">
                                <button
                                    [ngClass]="{
                                        disabled: isFirstMonth(monthStruct)
                                    }"
                                    class="c-picker-desktop-header-button"
                                    (click)="navigate(d, -1)"
                                >
                                    <ion-icon
                                        name="chevron-back-outline"
                                    ></ion-icon>
                                </button>
                                <span class="c-picker-desktop-header-year">
                                    {{
                                        d.i18n.getMonthShortName(
                                            monthStruct.month
                                        )
                                    }}
                                    {{ monthStruct.year }}</span
                                >
                                <button
                                    class="c-picker-desktop-header-button"
                                    (click)="navigate(d, 1)"
                                >
                                    <ion-icon
                                        name="chevron-forward-outline"
                                    ></ion-icon>
                                </button>
                            </div>
                            <ng-container
                                *ngTemplateOutlet="weekDayHeader"
                            ></ng-container>
                            <ngb-datepicker-month
                                class="c-picker-mobile-month"
                                [month]="monthStruct"
                            ></ngb-datepicker-month>
                        </div>
                    </div>
                    <div class="c-popup-footer">
                        <div>
                            <div
                                class="c-popup-header desktop"
                                *ngIf="totalNights > 0"
                            >
                                <div class="c-popup-header-nights">
                                    {{ totalNights }} {{ "nights" | translate }}
                                </div>
                                <div class="c-popup-header-dates">
                                    <span>{{ formattedFromDate }}</span>
                                    <span> - {{ formattedToDate }}</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button
                                mdTextButton
                                class="c-popup-footer-clear"
                                (click)="clearDateSelection()"
                            >
                                {{ "Clear Dates" | translate }}</button
                            ><button
                                mdMainButton="light"
                                class="c-popup-footer-apply"
                                [ngClass]="{
                                    disabled:
                                        !service.isSingleDate &&
                                        (!service.fromDate || !service.toDate)
                                }"
                                [disabled]="
                                    !service.isSingleDate &&
                                    (!service.fromDate || !service.toDate)
                                "
                                (click)="onApplyButtonClicked()"
                            >
                                {{ "Apply" | translate }}
                            </button>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!showDesktopInPopup">
                    <div class="c-picker-header on-desktop-inline">
                        <div>
                            <div class="c-picker-desktop-header">
                                <button
                                    class="c-picker-desktop-header-button"
                                    (click)="navigate(d, -1)"
                                >
                                    <ion-icon
                                        name="chevron-back-outline"
                                    ></ion-icon>
                                </button>
                                <span class="c-picker-desktop-header-year">
                                    {{
                                        d.i18n.getMonthShortName(
                                            d.state.months[0].month
                                        )
                                    }}
                                    {{ d.state.months[0].year }}</span
                                >
                                <button
                                    class="c-picker-desktop-header-button"
                                    (click)="navigate(d, 1)"
                                >
                                    <ion-icon
                                        name="chevron-forward-outline"
                                    ></ion-icon>
                                </button>
                            </div>
                        </div>
                        <ng-container
                            *ngTemplateOutlet="weekDayHeader"
                        ></ng-container>
                    </div>
                    <div
                        class="c-month-container"
                        *ngFor="let monthStruct of d.state.months"
                    >
                        <ngb-datepicker-month
                            class="c-picker-mobile-month"
                            [month]="monthStruct"
                        ></ngb-datepicker-month>
                    </div>
                </ng-container>
            </ng-container>
        </ng-template>
        <ng-template #weekDayHeader>
            <div class="c-picker-header-weekday">
                <span>{{ "Su" | translate }}</span>
                <span>{{ "Mo" | translate }}</span>
                <span>{{ "Tu" | translate }}</span>
                <span>{{ "We" | translate }}</span>
                <span>{{ "Th" | translate }}</span>
                <span>{{ "Fr" | translate }}</span>
                <span>{{ "Sa" | translate }}</span>
            </div>
        </ng-template>
    </ngb-datepicker>
</ng-template>
<ng-template #dayRangeSelect let-date let-focused="focused">
    <span
        [openDelay]="100"
        [class.c-disabled]="service.isDateDisabled(date)"
        class="c-day"
        [class.focused]="enableFocus && focused"
        [class.fromDate]="service.fromDate && service.fromDate.equals(date)"
        [class.toDate]="
            (service.toDate && service.toDate.equals(date)) ||
            service.isHoveredDate(date)
        "
        [class.range]="service.isRange(date)"
        [class.faded]="service.isHovered(date) || service.isInside(date)"
        (click)="stopPropagationIfDisabled($event)"
        (mouseenter)="enableHoveredDate && (service.hoveredDate = date)"
        (mouseleave)="enableHoveredDate && (service.hoveredDate = null)"
    >
        <span
            class="c-day-number"
            [ngClass]="{ 'has-price': getTooltip(date) }"
            >{{ date.day }}</span
        >
        <span class="c-day-price" *ngIf="getTooltip(date)">{{
            getTooltip(date)
        }}</span>
    </span>
</ng-template>
<ng-template #daySingleSelect let-date>
    <span
        [class.c-disabled]="service.isDateDisabled(date)"
        (click)="stopPropagationIfDisabled($event)"
        class="c-day"
        [class.single-date-selected]="
            service.singleDate && service.singleDate.equals(date)
        "
    >
        {{ date.day }}
    </span>
</ng-template>
<ng-template #footer>
    <div class="c-footer" *ngIf="showSelectionSummary">
        <div class="c-footer-labels" *ngIf="!service.isSingleDate">
            <span>{{ "Check-in" | translate }}</span>
            <span>{{ "Check-out" | translate }}</span>
            <span>{{ "Night(s)" | translate }}</span>
        </div>
        <div class="c-footer-values">
            <span>{{ formattedFromDate }}</span>
            <span>{{ formattedToDate }}</span>
            <span>{{ totalNights }}</span>
        </div>
        <button mdTextButton (click)="clearDateSelection()">
            {{ "Clear Dates" | translate }}
        </button>
    </div>
</ng-template>
<ng-template #mobileCalendar let-offcanvas>
    <div
        class="c-header-container"
        [ngClass]="{ 'no-dates': !formattedFromDate }"
    >
        <div class="c-header-title-container">
            <h4 class="offcanvas-title c-header-title">
                {{ "Select Dates" | translate }}
            </h4>
        </div>
        <button
            type="button"
            aria-label="Close"
            class="c-header-close-button"
            (click)="onModalCloseClick()"
        >
            <ion-icon name="close-outline"></ion-icon>
        </button>
    </div>
    <div class="c-modal-content">
        <ng-container *ngTemplateOutlet="actualCalendar"></ng-container>
        <div class="c-modal-footer">
            <div *ngIf="!showResetInFooter">
                <ng-content select="[summaryControl]"></ng-content>
            </div>
            <div>
                <a
                    class="c-modal-footer-reset"
                    (click)="clearDateSelection()"
                    *ngIf="showResetInFooter"
                    >{{ "Clear Dates" | translate }}</a
                >
            </div>

            <div class="c-modal-footer-button">
                <button
                    mdMainButton="light"
                    (click)="onApplyButtonClicked()"
                    [ngClass]="{
                        disabled:
                            !service.isSingleDate &&
                            (!service.fromDate || !service.toDate)
                    }"
                    [disabled]="
                        !service.isSingleDate &&
                        (!service.fromDate || !service.toDate)
                    "
                >
                    {{ "Apply" | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>
<div *ngIf="isInlineCalendarVisible">
    <h3 class="c-desktop-select">
        {{ "Select Check-In" | translate }}
    </h3>
    <ng-container *ngTemplateOutlet="actualCalendar"></ng-container>
</div>
<div *ngIf="showDesktopInPopup">
    <div
        class="c-po-dark-bkg"
        [ngClass]="{ open: isPopoverOpen }"
        *ngIf="darkBackgroundOnOpen"
    ></div>
    <div
        [ngbPopover]="actualCalendar"
        [autoClose]="'outside'"
        popoverClass="c-po-calendar"
        [placement]="isCalendarPopupBelow ? 'bottom-left' : 'auto'"
        [ngClass]="{
            'c-po-selecting-from-date': isPopoverOpen && !service.fromDate,
            'c-po-selecting-to-date': isPopoverOpen && service.fromDate
        }"
        triggers="manual"
        #p="ngbPopover"
        (click)="!dontCallOpenCalendarOnClick && openCalendar()"
        (shown)="onPopoverShown()"
        (hidden)="onPopoverHidden()"
    >
        <ng-content select="[popupTargetControl]"></ng-content>
    </div>
</div>
<div *ngIf="isInlineCalendarVisible && errorMessage" class="error-message">
    {{ errorMessage }}
</div>
